// eslint-disable-next-line import/prefer-default-export
import { createSelector } from 'reselect';

export const getProjects = ({ projects }) => projects.data;
export const getProjectsLoadingState = ({ projects }) => projects.loading;
export const getProjectsOptions = createSelector(
  getProjects,
  (items) => items.map(({ id: value, name: text, images = [] }) => ({ value, text, images })),
);

export const getProjectsLabelMap = createSelector(
  getProjects,
  (items) => items.reduce((result, { name, id }) => ({ ...result, [id]: name }), {}),
);
